import React, { createContext, useContext } from 'react';

import { MysteryShopRequestInbound } from '../types';

type EditShopRequestModalContent = {
  shopRequest: MysteryShopRequestInbound | null;
  originalShopRequest: MysteryShopRequestInbound | null;
  isLoading: boolean;
  refetchShopRequests: () => void | Promise<unknown>;
  setLoading: (value: boolean) => void;
  setShopRequest: (item: MysteryShopRequestInbound) => void;
};

export const EditShopRequestModalContext = createContext<EditShopRequestModalContent>({
  shopRequest: null,
  originalShopRequest: null,
  isLoading: false,
  refetchShopRequests: () => {
    // Do nothing
  },
  setLoading: () => {
    // empty
  },
  setShopRequest: () => {
    // empty
  },
});

export const useEditShopRequestModalContext = () => useContext(EditShopRequestModalContext);
